import { Outlet } from "react-router";

export const RedlineLayout = () => {
    return <Outlet />;
}